import React from 'react';
import { Route, useHistory, useRouteMatch, Switch, useParams } from "react-router-dom";
import Home from "./Home"
import Polls from "./Polls"
import {useRecoilValue, useRecoilState, useSetRecoilState} from "recoil";
import useTiming from "../../../../hooks/useTiming";
import useStripSearchParameters from '../../../../hooks/useStripSearchParameters';
import largeVideoState from "../../../../state/ui/largeVideoState";
import tabState from "../../../../state/ui/activeTabState";

const Booth = () => {

    const activeTab = useRecoilValue(tabState);
    const largeVideo = useRecoilValue(largeVideoState);

    return (
        <div className={`people tab-view overflow-hidden ${activeTab !== 1 ? 'hidden user-select-none' : ''} ${largeVideo ? 'people-large' : ''}`}>
            <div className="booth-page-container text-white">
                <Switch>
                    <Route path={`/:timing`} exact><Home /></Route>
                    <Route path={`/:timing/polls`}><Polls /></Route>
                </Switch>
            </div>
        </div>
    )
}

export default Booth